import { FormattedMessage } from 'react-intl';
import { Card } from '../../components/Card';
import { ShellContent } from '../../components/Shell';
import { useMenuConfig, useMenuOptions } from '../../services/menu';
import styles from './CustomiseMenu.module.css';
import { CustomiseItem } from './views';

export const CustomiseMenu = () => {
  const config = useMenuConfig();
  const options = useMenuOptions();

  return (
    <ShellContent noBackground>
      <div className={styles.root} data-testid="customise-menu-page">
        <div>
          <div className={styles.title}>
            <FormattedMessage id="Customise.ActiveItems" />
          </div>
          <Card className={styles.items}>
            {config.map((id) => (
              <CustomiseItem key={id} id={id} type="remove" />
            ))}
          </Card>
        </div>
        <div>
          <div className={styles.title}>
            <FormattedMessage id="Customise.AllItems" />
          </div>
          <Card className={styles.items}>
            {options.map(({ id }) => (
              <CustomiseItem key={id} id={id} type="add" />
            ))}
          </Card>
        </div>
      </div>
    </ShellContent>
  );
};
